import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import paymentOptionsConstant from 'src/app/shared/paymentOptionsConstant';
import { MerchantEditService } from '../../services/merchant-edit.service';
import { MerchantGetService } from '../../services/merchant-get.service';
import { ManageMerchantsComponent } from '../manage-merchants/manage-merchants.component';

const PaymentOptions=paymentOptionsConstant.constantgatePaymentOptions

@Component({
  selector: 'app-edit-merchant',
  templateUrl: './edit-merchant.component.html',
  styleUrls: ['./edit-merchant.component.scss']
})
export class EditMerchantComponent implements OnInit {

  id = -1;
  data = {};
  errorMessage = "";

  @ViewChild(ManageMerchantsComponent)
  ManageMerchantForm: ManageMerchantsComponent;

  constructor(
    private MerchantGet : MerchantGetService,
    private MerchantEdit : MerchantEditService,
    private route : Router,
    private activeRout : ActivatedRoute,
	  private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.activeRout.paramMap.subscribe( async params => {
      this.id = parseInt(params.get("id"));
      this.MerchantGet.setParams({id : this.id});
      try{
        let res = await this.MerchantGet.make();
        if(res.success){
          this.data = res.merchant;
          this.cdr.detectChanges();
          await this.ManageMerchantForm.ngOnInit();
          this.ManageMerchantForm.merchantForm.patchValue({
            merchant_name : this.data['name'],
            fname: this.data['fname'],
            lname: this.data['lname'],
            email : this.data['email'],
            mobile : this.data['mobile'],
            callBackUrl: this.data['callBackUrl']
          });
          let haveCash = false;
          for(let provider of this.data['MerchantProviders']){
            let cashprovider = this.ManageMerchantForm.cashProviders.filter(prov => prov['id'] === provider.providerId).length;
            if( cashprovider > 0){
              if(!haveCash){
                haveCash = true;
                this.ManageMerchantForm.removeCash(0);
                this.ManageMerchantForm.paymentOptionChange({ value :PaymentOptions.CASH});
              }
              let cashConfig = {
                providerId : provider['providerId'],
                flatRate : provider['flatRate'],
                OnUSRate : provider['OnUSRate'] ,
                OffUsRate : provider['OffUsRate']
              }
              for(let config of provider['config']){
                cashConfig[config['key']] = config['value'];
              }
              this.ManageMerchantForm.addCashProvider(cashConfig);
            } else {
              let creditConfig = {
                providerId : provider['providerId'],
                flatRate : provider['flatRate'],
                OnUSRate : provider['OnUSRate'] ,
                OffUsRate : provider['OffUsRate']
              }
              for(let config of provider['config']){
                if(config['key'] === "secureHashSecret"){
                  this.ManageMerchantForm.creditForm.addControl('secureHashSecret',new FormControl('',[ Validators.required]));
                }
                creditConfig[config['key']] = config['value'];
              }
              if(this.ManageMerchantForm.migsProviders.filter(prov => prov['id'] === provider.providerId).length > 0){
                this.ManageMerchantForm.paymentOptionChange({ value :PaymentOptions.MIGS_CREEDIT_CARD});

              } else {
                this.ManageMerchantForm.paymentOptionChange({ value :PaymentOptions.MPGS_CREEDIT_CARD});
              }
              this.ManageMerchantForm.creditForm.patchValue(creditConfig);
            }
          }

        } else {
          this.errorMessage = res.message;
        }
      }catch(err){
        this.errorMessage = err.message;
      }
    })
  }


  async editMerchant(event : object){
    this.MerchantEdit.setParams({...event , id : this.id});
    try{
      let res = await this.MerchantEdit.make();
      if(res.success){
        this.route.navigate(['/admin/actions/merchants']);
      } else {
        this.errorMessage = res.message;
        this.cdr.detectChanges()
      }
      }catch(err){
        this.errorMessage = err.error.message;
        this.cdr.detectChanges()
      }
  }

}
